import styled from 'styled-components';
import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-common';
// Styled components
export const GalleryContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  display: flex;
`;

export const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  transition: transform 0.5s ease;
  align-items: flex-start;
`;

export const StyledSlideImage = styled.img`
  width: 100%;

  flex-shrink: 0;
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
  opacity: 1;
  cursor: grab;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  width: calc(100% - 32px);
  height: auto;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  padding: 0 16px;
  & > button {
    color: rgb(0, 0, 0);
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: calc(100% - 80px);
    padding: 0 40px;
  }
`;

export const NavButtonContainer = styled.div`
  display: flex;
  height: 48px;
  gap: 3px;
  justify-content: flex-end;
  color: rgb(0, 0, 0);

  div {
    background-color: #fff;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2) !important;
    border: none !important;

    button {
      border: none;
    }
  }

  &.stage-controls {
    display: none;
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: flex;
    }
  }
`;

export const MobileNavButtonContainer = styled.div`
  display: flex;
  min-height: 48px;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: none;
  }
`;

export const LayerNavButtonContainer = styled.div`
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
  }
`;

export const FullScreenPictureContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
